import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-base" }



export default /*@__PURE__*/_defineComponent({
  __name: 'MsgMineMenu',
  emits: ["menuAction"],
  setup(__props, { emit: __emit }) {

const action = (index: number) => {
  emit("menuAction", index);
};

const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_CopyDocument = _resolveComponent("CopyDocument")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)),
    false
      ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          effect: "dark",
          content: "编辑",
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              color: `#888888`,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (action(1))),
              class: "icon",
              size: 20
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Edit)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_tooltip, {
      effect: "dark",
      content: "复制",
      placement: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_icon, {
          color: `#888888`,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (action(0))),
          class: "icon",
          size: 20
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CopyDocument)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})